<template>
  <div class="advance">
        <div class="title">预付金额</div>
        <div style="display:flex">
            <img class="zhifubao" src="@/assets/fannmiao.png" />
            <div style="margin-left:30px;margin-top:10px;">
                <div class="titl">
                  1. 预付金支付方方式尽可能采用及账号进行支付，以便我们及时的提供服务。<br/>
                  2. 预付金预付后享受8折入驻加盟费<br/>
                  3. 预付金可以随时进行退换。<br/>
                  4. 预付金可以抵扣入驻加盟费。<br/>
                </div>
                <div style="margin-top:7px;">
                    <span class="text">金额：</span>
                    <span class="money">199</span>
                    <span class="money" style="font-size:30px">.00</span>
                    <span class="money" style="font-size:36px;margin-left:8px;">元</span>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      list:[
        
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .advance{
     .title{
      font-size: 24px;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      color: #333333;
      font-weight:600;
     }
     .zhifubao{
          width:180px;
          height:auto;
          border:1px solid rgba(0, 0, 0, 0.1);
          border-radius:6px;
          margin-top:30px;
     }
     .titl{
        font-size: 12px;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        color: #333333;
        line-height: 24px;
        margin-top: 13px;
     }
     .text{
        font-size: 16px;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        color: #333333;
        margin-right:10px;
     }
     .money{
        font-size: 54px;
        font-family: Gilroy, Gilroy;
        font-weight: 500;
        color: #F54040;
     }

  }
</style>